module.exports = __webpack_public_path__ + "static/media/solace-discovery-frame.b050f0fc.png";